import { Redirect, Route, useLocation } from 'react-router-dom';
import api from 'api/client';
import React, { useEffect } from 'react';
import { handleUtmAndReferral } from 'utils/handleUtmParams';

const PublicRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const location = useLocation();

  // ── Run on every render (before redirect) so localStorage is always written
  // before the <Redirect> fires. useEffect is too late — redirect happens first.
  const queryParams = new URLSearchParams(location.search);
  const method = queryParams.get('method');
  const action = queryParams.get('action');
  const sip = queryParams.get('sip');
  const dist = queryParams.get('dist');
  const stg = queryParams.get('stg');

  if (action || sip) {
    const by = queryParams.get('by');
    const amt = queryParams.get('amt');
    const dist = queryParams.get('dist');
    const metal = queryParams.get('metal');
    const sipint = queryParams.get('sipint');

    localStorage.setItem(
      'prefillParams',
      JSON.stringify({ action, by, amt, dist, metal, sip, sipint })
    );
  }

  if (method === 'BMM') {
    localStorage.setItem(
      'prefillParams',
      JSON.stringify({
        action: 'multimetal',
        dist: dist ?? '',
        // stg=3 means multimetal, already implied by BMM
      })
    );
  }
  // ── end prefillParams save ──────────────────────────────────────────────────

  useEffect(() => {
    handleUtmAndReferral(location);
    const queryParams = new URLSearchParams(location.search);

    const method = queryParams.get('method');
    const metal = queryParams.get('metal');
    const amt = queryParams.get('amt');
    const stg = queryParams.get('stg');
    const dist = queryParams.get('dist');

    if (method) {
      localStorage.setItem('deepLinkParams', JSON.stringify({
        method, metal, amt, stg, dist
      }));
    }


    const allParamsObj = {};
    queryParams.forEach((value, key) => {
      allParamsObj[key] = value;
    });
    const data = {
      utmSource: queryParams.get('utm_source'),
      utmMedium: queryParams.get('utm_medium'),
      utmCampaign: queryParams.get('utm_campaign'),
      source: 'web',
    };
    localStorage.setItem('utmData', JSON.stringify(data));
    localStorage.setItem('buyMethod', JSON.stringify(allParamsObj));

    const sipData = new URLSearchParams(location.search).get('sipdata');
    const manualSipData = new URLSearchParams(location.search).get('manualSipData');
    let corpVoucherCode = new URLSearchParams(location.search).get('voucherCode');

    if (sipData !== null) {
      try {
        const decodedSipData = decodeURIComponent(sipData);
        JSON.parse(decodedSipData); // validate
        localStorage.setItem('sipdata', decodedSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    } else if (manualSipData !== null) {
      try {
        const decodedmanualSipData = decodeURIComponent(manualSipData);
        localStorage.setItem('manualSipData', decodedmanualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
    if (manualSipData !== null) {
      try {
        localStorage.setItem('manualSipData', manualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
    if (corpVoucherCode) {
      localStorage.setItem('corpVoucherCode', corpVoucherCode);
    }
  }, [location.search]);


  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        token ? (
          <Redirect
            to={{
              pathname: '/dashboard',
              search: location.search,
            }}
          />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
